import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Thank you for your message! We will get back to you soon.');
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-4">Contact Us</h1>
          <p className="text-lg text-muted-foreground mb-12">We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <form onSubmit={handleSubmit} className="border border-border/40 rounded-sm p-6 bg-card space-y-4">
                <div>
                  <Label htmlFor="name">Name</Label>
                  <Input
                    id="name"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    required
                    className="rounded-sm"
                    data-testid="contact-name-input"
                  />
                </div>
                <div>
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    value={form.email}
                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                    required
                    className="rounded-sm"
                    data-testid="contact-email-input"
                  />
                </div>
                <div>
                  <Label htmlFor="subject">Subject</Label>
                  <Input
                    id="subject"
                    value={form.subject}
                    onChange={(e) => setForm({ ...form, subject: e.target.value })}
                    required
                    className="rounded-sm"
                    data-testid="contact-subject-input"
                  />
                </div>
                <div>
                  <Label htmlFor="message">Message</Label>
                  <Textarea
                    id="message"
                    value={form.message}
                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                    required
                    className="rounded-sm"
                    rows={6}
                    data-testid="contact-message-input"
                  />
                </div>
                <Button type="submit" size="lg" className="rounded-sm" data-testid="contact-submit-btn">
                  Send Message
                </Button>
              </form>
            </div>

            <div className="space-y-6">
              <div className="border border-border/40 rounded-sm p-6 bg-card">
                <div className="flex items-center gap-3 mb-2">
                  <Mail size={20} className="text-accent" />
                  <h3 className="font-playfair font-bold text-foreground">Email</h3>
                </div>
                <p className="text-sm text-muted-foreground">contact@insidehighereducation.eu</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}